/**
 * Temporary feature flag for Auctions Near Me migration
 *
 * This boolean constant controls whether to use the new catalog-management API + google maps component
 * or the existing Algolia implementation.
 *
 * TODO: Replace with OpenFeature when POC is merged
 *
 * @see https://catalog-management-prod.liveauctioneers.com/cms/catalogs/near-me
 * @see https://liveauctioneers.atlassian.net/browse/SG-229
 */
export const FF_SG229_NEW_AUCTIONS_NEAR_ME_PAGE = false;
